module.exports = __webpack_public_path__ + "static/media/social-jumbo.50e71108.jpg";